var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../components/header-bar.njk"] = require( "../components/header-bar.njk" );




var shim = require("D:/workspace/indivior-listmypractice-release/frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/views/components/header.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<a class=\"skip-link\" href=\"#main-content\">Skip to main content</a>\r\n<header class=\"global-header\" id=\"global-header\">\r\n\t<div class=\"us-only-header\">\r\n\t\t<div class=\"container\">\r\n\t\t\t<p>This site is intended for US healthcare providers.</p>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div class=\"logo-header\">\r\n\t\t<div class=\"container\">\r\n\t\t\t<div class=\"logo-header__content\">\r\n\t\t\t\t<a class=\"logo-link\" href=\"/\"><img data-ot-ignore src=\"/assets/img/shared/indivior_logo@2x.png\" alt=\"Go to Homepage\"></a>\r\n\t\t\t\t<div class=\"logo-header__cta\">\r\n\t\t\t\t\t<a href=\"/terms-of-conditions\" class=\"header__cta terms btn btn-min-width btn-primary\"><span class=\"btn-content\">Terms and Conditions</span></a>\r\n\t\t\t\t\t<a href=\"/faqs\" class=\"header__cta help btn btn-min-width btn-secondary\"><span class=\"btn-content\">Help</span></a>\r\n\t\t\t\t</div>\t\t\t\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div class=\"headline-header\">\r\n\t\t<div class=\"container\">\r\n\t\t\t<div class=\"heading-container\">\r\n\t\t\t\t<div class=\"heading\">List My Practice</div>\r\n\t\t\t\t<div class=\"sub-heading\">\r\n\t\t\t\t\t<i><strong>For use by healthcare providers who prescribe SUBLOCADE&reg;&nbsp;(buprenorphine extended&#8209;release) to access and edit practice locations for use on the Indivior Find a SUBLOCADE Treatment Provider Tool for&nbsp;patients.</strong></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t";
if(runtime.contextOrFrameLookup(context, frame, "showHCPHeader")) {
output += " \r\n\t\t";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("../components/header-bar.njk", false, "src/views/components/header.njk", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
callback(null,t_1);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_4,t_3) {
if(t_4) { cb(t_4); return; }
callback(null,t_3);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n\t";
});
}
output += "\r\n</header>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/views/components/header.njk"] , dependencies)